import { call, put, takeEvery } from "redux-saga/effects";

import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { eLopActionIds, ILopActionTypes } from "../../action-types/category/ILopActions";
import { lopApi } from "../../../api/category/lopApi";

export function* lopSaga(): any {
  yield takeEvery(eLopActionIds.LOAD_LOP_BY_USER_START, loadWorker);
  yield takeEvery(eLopActionIds.LOAD_ALL_START, loadAllWorker);
}

 function* loadWorker(action: ILopActionTypes): any {
    const res: IBaseRespone = yield call(lopApi.SelectByUser);
    if (res.is_success) {
        yield put(rootActions.category.lop.LOAD_LOP_BY_USER_SUCCESS(res.data));
    } else {
        yield put(rootActions.category.lop.LOAD_LOP_BY_USER_ERROR(res.message ?? "Có lỗi"));
    }
}


 function* loadAllWorker(action: ILopActionTypes): any {
  const res: IBaseRespone = yield call(lopApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.lop.LOAD_ALL_SUCCESS(res.data));
  } else {
    yield put(rootActions.category.lop.LOAD_ALL_ERROR(res.message ?? "Có lỗi"));
  }
}